import { render, staticRenderFns } from "./DocumentDateSelector.vue?vue&type=template&id=a61e7e24&"
import script from "./DocumentDateSelector.vue?vue&type=script&lang=js&"
export * from "./DocumentDateSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports